const PROFESSIONAL_ADVICE = [
    { code: '01', label: 'CRESS (SERVIÇO SOCIAL)', key: 'cress' },
    { code: '02', label: 'COREN (ENFERMAGEM)', key: 'coren' },
    { code: '03', label: 'CRF (FARMÁCIA)', key: 'crf' },
    { code: '04', label: 'CREFONO (FONOAUDIOLOGIA)', key: 'crefono' },
    { code: '05', label: 'CREFITO (FISIOTERAPIA E TERAPIA OCUPACIONAL)', key: 'crefito' },
    { code: '06', label: 'CRM (MEDICINA)', key: 'crm' },
    { code: '07', label: 'CRN (NUTRIÇÃO)', key: 'crn' },
    { code: '08', label: 'CRO (ODONTOLOGIA)', key: 'cro' },
    { code: '09', label: 'CRP (PSICOLOGIA)', key: 'crp' },
    { code: '10', label: 'CRQ (QUÍMICA)', key: 'crq' },
    { code: '11', label: 'CRBIO (BIOLOGIA)', key: 'crbio' },
    { code: '12', label: 'CRBM (BIOMEDICINA)', key: 'crbm' },
    { code: '13', label: 'CREF (EDUCAÇÃO FÍSICA)', key: 'cref' },
    { code: '14', label: 'CRMV (MEDICINA VETERINÁRIA)', key: 'crmv' },
    { code: '15', label: 'CRTR (RADIOLOGIA)', key: 'crtr' },
]

const CBO = [
    { code: '2251-12', label: 'MÉDICO NEUROLOGISTA', key: 'neurologist' },
    { code: '2251-20', label: 'MÉDICO CARDIOLOGISTA', key: 'cardiologist' },
    { code: '2251-24', label: 'MÉDICO PEDIATRA', key: 'pediatrician' },
    { code: '2251-25', label: 'MÉDICO CLÍNICO (GERAL)', key: 'general_clinical_practitioner' },
    { code: '2251-30', label: 'MÉDICO DE FAMÍLIA E COMUNIDADE', key: 'family_and_community_medicine' },
    { code: '2251-33', label: 'MÉDICO PSIQUIATRA', key: 'psychiatrist' },
    { code: '2251-35', label: 'MÉDICO DERMATOLOGISTA', key: 'dermatologist' },
    { code: '2251-40', label: 'MÉDICO DO TRABALHO', key: 'occupational_medicine' },
    { code: '2251-70', label: 'MÉDICO GENERALISTA', key: 'general_practitioner' },
    { code: '2251-80', label: 'MÉDICO GERIATRA', key: 'geriatrician' },
    { code: '2252-10', label: 'MÉDICO CIRURGIÃO CARDIOVASCULAR', key: 'cardiovascular_surgeon' },
    { code: '2252-25', label: 'MÉDICO CIRURGIÃO GERAL', key: 'general_surgeon' },
    { code: '2252-50', label: 'MÉDICO GINECOLOGISTA E OBSTETRA', key: 'gynecologist_and_obstetrician' },
    { code: '2252-70', label: 'MÉDICO ORTOPEDISTA E TRAUMATOLOGISTA', key: 'orthopedist_and_traumatologist' },
    { code: '2252-75', label: 'MÉDICO OTORRINOLARINGOLOGISTA', key: 'otorhinolaryngologist' },
    { code: '2252-85', label: 'MÉDICO UROLOGISTA', key: 'urologist' },
    { code: '2252-95', label: 'MÉDICO NEUROCIRURGIÃO', key: 'neurosurgeon' },
    { code: '2253-20', label: 'MÉDICO EM RADIOLOGIA E DIAGNÓSTICO POR IMAGEM', key: 'radiologist' },
    { code: '2131-50', label: 'FÍSICO MÉDICO', key: 'medical_physicist' },
    { code: '2234-05', label: 'FARMACÊUTICO', key: 'pharmacist' },
    { code: '2235-05', label: 'ENFERMEIRO', key: 'nurse' },
    { code: '2235-30', label: 'ENFERMEIRO OBSTETRA', key: 'obstetric_nurse' },
    { code: '2236-05', label: 'FISIOTERAPEUTA GERAL', key: 'general_physiotherapist' },
    { code: '2237-10', label: 'NUTRICIONISTA', key: 'nutritionist' },
    { code: '2238-10', label: 'FONOAUDIÓLOGO GERAL', key: 'speech_therapist' },
    { code: '2239-05', label: 'TERAPEUTA OCUPACIONAL', key: 'occupational_therapist' },
    { code: '2515-10', label: 'PSICÓLOGO CLÍNICO', key: 'clinical_psychologist' },
    { code: '2232-08', label: 'CIRURGIÃO-DENTISTA - CLÍNICO GERAL', key: 'dentist_general_practitioner' },
    { code: '2232-12', label: 'CIRURGIÃO-DENTISTA - ENDODONTISTA', key: 'endodontist' },
    { code: '2232-24', label: 'CIRURGIÃO-DENTISTA - IMPLANTODONTISTA', key: 'implantodontist' },
    { code: '2232-36', label: 'CIRURGIÃO-DENTISTA - ODONTOPEDIATRA', key: 'pediatric_dentist' },
    { code: '2232-40', label: 'CIRURGIÃO-DENTISTA - ORTOPEDISTA E ORTODONTISTA', key: 'orthodontist' },
    { code: '2232-48', label: 'CIRURGIÃO-DENTISTA - PERIODONTISTA', key: 'periodontist' },
    { code: '3222-05', label: 'TÉCNICO DE ENFERMAGEM', key: 'nursing_technician' },
    { code: '3222-10', label: 'TÉCNICO DE ENFERMAGEM DE TERAPIA INTENSIVA', key: 'intensive_care_nursing_technician' },
    { code: '3222-15', label: 'TÉCNICO DE ENFERMAGEM DO TRABALHO', key: 'occupational_health_nursing_technician' },
    { code: '3222-25', label: 'INSTRUMENTADOR CIRÚRGICO', key: 'surgical_instrumentalist' },
    { code: '3222-30', label: 'AUXILIAR DE ENFERMAGEM', key: 'nursing_assistant' },
    { code: '3222-35', label: 'AUXILIAR DE ENFERMAGEM DO TRABALHO', key: 'occupational_health_nursing_assistant' },
    { code: '3224-05', label: 'TÉCNICO EM SAÚDE BUCAL', key: 'oral_health_technician' },
    { code: '3224-15', label: 'AUXILIAR EM SAÚDE BUCAL', key: 'oral_health_assistant' },
    { code: '3224-20', label: 'AUXILIAR DE PRÓTESE DENTÁRIA', key: 'dental_prosthesis_assistant' },
    { code: '3241-15', label: 'TÉCNICO EM RADIOLOGIA E FLUOROSCOPIA', key: 'radiology_and_fluoroscopy_technician' },
    { code: '3241-20', label: 'TECNÓLOGO EM RADIOLOGIA', key: 'radiology_technologist' },
    { code: '3242-05', label: 'TÉCNICO DE LABORATÓRIO DE ANÁLISES CLÍNICAS', key: 'clinical_analysis_laboratory_technician' },
    { code: '5151-05', label: 'AGENTE COMUNITÁRIO DE SAÚDE', key: 'community_health_agent' },
    { code: '5151-25', label: 'AGENTE INDÍGENA DE SAÚDE', key: 'indigenous_health_agent' },
    { code: '5151-40', label: 'AGENTE DE COMBATE ÀS ENDEMIAS', key: 'endemic_disease_control_agent' },
    { code: '5162-10', label: 'CUIDADOR DE IDOSOS', key: 'elderly_caregiver' },
]

export {
    PROFESSIONAL_ADVICE,
    CBO
}